import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';

import {getMonth, getYear} from 'date-fns';
import {range} from 'lodash-es';
import React from 'react';
import DatePickerLib from 'react-datepicker';

import {Select} from '@/components/common/Input';

import {months} from './months';

// react-datepicker@4 ships a UMD `browser` bundle (dist/react-datepicker.min.js)
// that Vite loads by default (resolve.mainFields prefers `browser`). That bundle
// sets `exports.default`/`exports.CalendarContainer` without an interop
// `__esModule` flag, so `import DatePicker from 'react-datepicker'` resolves to
// the whole module namespace object `{default, CalendarContainer, ...}` instead
// of the component — which React rejects with "type is invalid ... got: object".
// Unwrap `.default` when present so we always get the component.
const DatePicker =
  (DatePickerLib as unknown as {default?: typeof DatePickerLib}).default ??
  DatePickerLib;

export interface CalendarProps {
  label?: string;
  selectedDate?: Date;
  setSelectedDate?: (date: Date) => void;
  showTime?: boolean;
  /**
   * Minutes between the time-dropdown options. A prop rather than something
   * `...props` carries, because the spread runs before these options and a
   * caller-supplied value was silently discarded.
   */
  timeIntervals?: number;
  /**
   * The calendar renders into this portal node rather than inline, so a
   * scrolling ancestor cannot clip it. Named rather than left to `...props`
   * for the same reason as `timeIntervals`.
   */
  portalId?: string;
  containerStyle?: string | undefined;
  [key: string]: unknown;
}

const Datepicker = ({
  label,
  selectedDate,
  setSelectedDate,
  showTime = false,
  timeIntervals = 5,
  portalId = 'datepicker-portal',
  containerStyle,
  ...props
}: CalendarProps) => {
  const years = range(1970, getYear(new Date()) + 2, 1);

  const datePickerProps = {
    className: containerStyle || 'w-auto',
  };

  return (
    <div {...datePickerProps}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-100 mb-1">
          {label}
        </label>
      )}
      <DatePicker
        {...props}
        dateFormat={showTime ? 'dd/MM/yyyy h:mm aa' : 'dd/MM/yyyy'}
        selected={selectedDate}
        autoComplete="off"
        showTimeSelect={showTime}
        timeFormat="h:mm aa"
        timeIntervals={timeIntervals}
        timeCaption="Time"
        portalId={portalId}
        onChange={(date: Date | null) => setSelectedDate?.(date as Date)}
        className={`block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm dark:bg-transparent dark:border-dark-borderMid dark:text-gray-200`}
        renderCustomHeader={({date, changeYear, changeMonth}) => {
          return (
            <div className="flex items-center justify-center gap-3 b-1">
              <Select
                name="startDate"
                className="rounded-md border-none w-24 text-sm font-sans"
                value={months[getMonth(date)].value}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  changeMonth(
                    months.findIndex((month) => month.value === e.target.value),
                  )
                }
                options={months}
              />
              <Select
                className="rounded-md border-none w-24 text-sm font-sans"
                value={getYear(date)}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  changeYear(Number(e.target.value))
                }
                options={years.map((year) => ({
                  key: year.toString(),
                  value: year.toString(),
                }))}
              />
            </div>
          );
        }}
      />
    </div>
  );
};

export default Datepicker;
